// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".question__wrapper[data-v-5d41ec69]{margin:20px 0 120px}.question__button[data-v-5d41ec69]{max-width:270px;width:100%;height:50px;font-size:16px;font-weight:700;line-height:20px;text-transform:uppercase}.question__button[data-v-5d41ec69]:hover{background-color:#000;color:#fff}", ""]);
// Exports
module.exports = exports;
